import { render, staticRenderFns } from "./productDemonstration.vue?vue&type=template&id=64bd02e8&scoped=true"
import script from "./productDemonstration.vue?vue&type=script&lang=js"
export * from "./productDemonstration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd02e8",
  null
  
)

export default component.exports